import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

import { EventContentTab } from "@features/offer/shared/event";

export const StreaksStatisticsButton = observer(
	function StreaksStatisticsButton(props: {
		store: EventViewStore | AdditionalOfferViewStore;
	}) {
		const { t } = useTranslation();

		return (
			<EventContentTab
				textContent={t("EVENT.HEADER.STREAKS")}
				isActive={
					props.store.displayStatisticsGroup ===
					StatisticsGroups.StreakStats
				}
				onClick={() =>
					props.store.setDisplayStatisticsGroup(
						StatisticsGroups.StreakStats
					)
				}
			/>
		);
	}
);
